import { MutationTree } from 'vuex'

import _get from 'lodash/get'

import { OffersState } from './types'
import { state as initialState } from './index'
import { Seller, Offer, OfferItem } from '../../types'

export const mutations: MutationTree<OffersState> = {
  reset(state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },
  setOffer(state, payload: { offer: Offer }) {
    state.offer = payload.offer
    state.requestGetOffer = false
    state.requestUploadInventoryList = false
    state.error = null
  },
  offerProcessed(state, payload: boolean) {
    state.requestPostOfferProcess = false
    state.offerProcessed = true
  },
  setError(state, payload) {
    state.requestGetOffers = false
    state.requestGetOffer = false
    state.requestPostOfferProcess = false
    state.error = payload
  },
  setRequestGetOffer(state, payload: boolean) {
    state.requestGetOffer = payload
    state.error = null
  },
  setRequestGetOffers(state, payload: boolean) {
    state.requestGetOffers = payload
    state.error = null
  },
  setRequestPostProcess(state, payload: boolean) {
    state.requestPostOfferProcess = payload
    state.error = null
  },
  setRequestUploadInventoryList(state, payload: boolean) {
    state.requestUploadInventoryList = payload
    state.error = null
  },
}
